/**
 * Resolve a flag image URL for a currency row, using flagcdn.com.
 *
 * Priority:
 *   1. Backend-supplied ISO-2 country code (preferred — keeps canonical
 *      mapping server-side).
 *   2. A small fallback map for currencies that don't cleanly belong to
 *      a single country (EUR, XAF, XOF, XCD, XPF).
 *   3. Empty string — caller will fall back to a label-only render.
 */

// Currencies without a single sovereign country. Values point at the
// flagcdn "region" flag (EU) or a representative member state.
const CURRENCY_FALLBACK_CC: Record<string, string> = {
  EUR: 'eu',
  XAF: 'cm', // Central African CFA — Cameroon as representative
  XOF: 'sn', // West African CFA — Senegal as representative
  XCD: 'ag', // East Caribbean Dollar — Antigua & Barbuda as representative
  XPF: 'pf', // CFP Franc — French Polynesia
};

export function flagUrl(countryCode: string | null | undefined, currencyCode: string): string {
  const cc = (countryCode || CURRENCY_FALLBACK_CC[currencyCode.toUpperCase()] || '').toLowerCase();
  if (!cc || !/^[a-z]{2}$/.test(cc)) return '';
  return `https://flagcdn.com/w40/${cc}.png`;
}
